import { Typography, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

const styles = (theme) => {
  const colors = Object.entries(theme.colors).reduce(
    (obj, [key, val]) => ({ ...obj, [key]: { color: val } }),
    {},
  );

  return {
    text: {
      fontSize: 9,
      lineHeight: "9px",
      fontFamily: "Larsseit-Medium",
    },
    ellipsis: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    obscure: {
      filter: "blur(3px)",
      userSelect: "none",
    },
    ...colors,
  };
};

function Micro({ children, classes, ...props }) {
  const classnames = Object.keys(props)
    .map((k) => props[k] && classes[k])
    .join(" ");

  return <Typography className={`${classes.text} ${classnames}`}>{children}</Typography>;
}

Micro.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  classes: PropTypes.object.isRequired,
};

export default React.memo(withStyles(styles)(Micro));
